import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
	getProfileDetails,
	toggleEdit,
} from '../../redux/profile/profile.actions';

import Card from 'react-bootstrap/Card';

const ProfileReadOnly = ({
	getProfileDetails,
	toggleEdit,
	details: {
		fullName,
		gender,
		age,
		phone,
		email,
		userType,
		userTypeOther,
		childrenAge,
		whatsappNumber,
		fieldPrimaryPurpose,
		primaryPurpose,
		isParent,
		primaryPurposeOther,
		isSubscribe,
	},
}) => {
	useEffect(() => {
		getProfileDetails();
	}, [getProfileDetails]);

	let genderList = [
		{ id: 'M', val: 'Male' },
		{ id: 'F', val: 'Female' },
		{ id: 'T', val: 'Transgender' },
		{ id: 'O', val: 'Rather not say' },
	];
	let genderSelected = genderList.filter((x) => x.id === gender);

	return (
		<div className="row">
			<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
				<Card>
					<Card.Body>
						<div>
							<div className="page-header-left">Personal Information</div>
							<button
								aria-label="edit"
								className="btn-edit-profile"
								onClick={toggleEdit}
							>
								Edit
							</button>
						</div>

						<div className="profile-info-display">
							<div className="row">
								<div className="col-md-4">
									<label>Name</label>
								</div>
								<div className="col-md-8">
									<p>{fullName || '-'}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Gender</label>
								</div>
								<div className="col-md-8">
									<p>{!!gender && !!genderSelected[0] ? genderSelected[0].val : `-`}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Age</label>
								</div>
								<div className="col-md-8">
									<p>{age || '-'}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Phone</label>
								</div>
								<div className="col-md-8">
									<p>{phone || '-'}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Email</label>
								</div>
								<div className="col-md-8">
									<p>{email || '-'}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Who are you?</label>
								</div>
								<div className="col-md-8">
									<p>{userType || '-'}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Purpose of using STEP</label>
								</div>
								<div className="col-md-8">
									<p>{primaryPurpose || '-'}</p>
								</div>
							</div>

							<div className="row" style={{ display: isParent ? 'flex' : 'none' }}>
								<div className="col-md-4">
									<label>Children Age</label>
								</div>
								<div className="col-md-8">
									<p>{childrenAge || '-'}</p>
								</div>
							</div>
							<div className="row" style={{ display: 'flex' }}>
								<div className="col-md-4">
									<label>
										Subscribed to receive updates (and offers) on our English courses?
									</label>
								</div>
								<div className="col-md-8">
									<p>{isSubscribe ? 'Yes' : 'No'}</p>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<label>Whatsapp Number</label>
								</div>
								<div className="col-md-8">
									<p>{whatsappNumber || '-'}</p>
								</div>
							</div>
						</div>
					</Card.Body>
				</Card>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		details: state.rootReducer.profileDetails,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProfileDetails: () => dispatch(getProfileDetails()),
		toggleEdit: () => dispatch(toggleEdit()),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileReadOnly);
